'use strict';

import execute_on from "../../../../libs/execute-on";
import reportScripts from "./reportScript";

execute_on('panel.survey.report.show-by-token', reportScripts);
execute_on('panel.survey.report.show', reportScripts);
